// services/api.js
import axios from 'axios';

class SecureApiService {
    constructor() {
        this.axiosInstance = null;
        this.setupAxios();
    }

    setupAxios() {
        this.axiosInstance = axios.create({
            baseURL: process.env.REACT_APP_API_KEY,
            timeout: 10000,
            withCredentials: true // ✅ CRITICAL: Send cookies with requests
        });

        // ✅ REQUEST INTERCEPTOR: Read client token and send as header
        // this.axiosInstance.interceptors.request.use(
        //     (config) => {
        //         // Read the client token from the readable cookie
        //         // this.debugCookies();
        //         const clientToken = this.getCookie('booking_client_token');
        //         if (clientToken) {
        //             config.headers['Authorization'] = clientToken; // ✅ CRITICAL: Send as header
        //         }
        //
        //         console.log('Making request with headers:', config.headers);
        //         return config;
        //     },
        //     (error) => {
        //         return Promise.reject(error);
        //     }
        // )

        // ✅ RESPONSE INTERCEPTOR
        // this.axiosInstance.interceptors.response.use(
        //     (response) => {
        //         console.log('Response received, cookies should be set automatically');
        //         return response;
        //     },
        //     (error) => {
        //         console.error('API Error:', error.response?.status);
        //         if (error.response?.status === 401) {
        //             this.clearSession();
        //             window.location.href = '/?session_expired=true';
        //         }
        //         return Promise.reject(error);
        //     }
        // );
    }

    // ✅ METHOD TO READ COOKIES
    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
        return null;
    }

    clearSession() {
        // Cookies are managed by browser, but we can try to clear them
        document.cookie = "booking_session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=None; Secure";
        document.cookie = "booking_client_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=None; Secure";
    }

    // ✅ DEBUG METHOD: Check what cookies are available
    debugCookies() {
        console.log('All cookies:', document.cookie);
        console.log('Client token cookie:', this.getCookie('booking_client_token'));
        console.log('Session cookie exists:', !!this.getCookie('booking_session')); // Should be false due to HttpOnly
    }

    async getAdditionalServices() {
        const response = await this.axiosInstance.get('/arscustom/public/services/additional-services');
        return response.data;
    }

    async getTintGlassService(tintId) {
        const response = await this.axiosInstance.get('/arscustom/public/services/tint-glass-services/single', {
            params: { id: tintId }
        });
        return response.data;
    }

    // API methods
    async selectTintGlass(tintGlassId) {
        const response = await this.axiosInstance.post('/arscustom/public/appointment/select-tint-glass', {
            tintGlassServiceId: tintGlassId
        });
        return response.data;
    }

    async addAdditionalService(serviceId) {
        const response = await this.axiosInstance.post('/arscustom/public/appointment/add-additional-service', {
            additionalServiceId: serviceId
        });
        return response.data;
    }

    async removeAdditionalService(serviceId) {
        const response = await this.axiosInstance.post('/arscustom/public/appointment/remove-additional-service', {
            additionalServiceId: serviceId
        });
        return response.data;
    }

    async getAvailableTimes(date) {
        const response = await this.axiosInstance.get('/arscustom/public/appointment/available-times', {
            params: { dateStr: date }
        });
        return response.data.availableTimes || [];
    }

    async selectTime(time) {
        const response = await this.axiosInstance.post('/arscustom/public/appointment/select-time', {
            time: time
        });
        return response.data;
    }

    async setUserInfo(userInfo) {
        const response = await this.axiosInstance.post('/arscustom/public/appointment/set-user-info', userInfo);
        return response.data;
    }

    async getInformation() {
        const response = await this.axiosInstance.get('/arscustom/public/appointment/get-information');
        return response.data;
    }

    async preconfirm(language) {
        if(language === 'fr-FR') {
            language = 'fr'
        } else if(language === 'en-US') {
            language = 'en'
        }
        const response = await this.axiosInstance.post(`/arscustom/public/appointment/preconfirm?language=${language}`);
        return response.data;
    }

}

export default new SecureApiService();